export function debounce<Params extends any[]>(
  fn: (...args: Params) => any,
  timeout: number,
): (...args: Params) => void {
  let timer: number;
  return (...args: Params) => {
    clearTimeout(timer);
    timer = window.setTimeout(() => {
      fn(...args);
    }, timeout);
  };
}

export function invariant<T>(value: T | null): T {
  if (value === null) {
    throw new Error("invariant: encountered unexpected null value");
  }
  return value;
}

export function onEvent(
  eventTarget: EventTarget,
  event: string,
): Promise<void> {
  return new Promise((resolve) => {
    eventTarget.addEventListener(
      event,
      () => {
        resolve();
      },
      {
        once: true,
      },
    );
  });
}

export function parseIntNullable(value: string | null) {
  const numberValue = parseInt(value ?? "", 10);
  if (isNaN(numberValue)) return null;
  return numberValue;
}

export function toLookup<T, K>(
  items: T[],
  keyExtractor: (index: T) => K,
): Map<K, T> {
  return items.reduce(
    /**
     * @param {Map<K, T>} lookup
     * @param {T} item
     * @returns {Map<K, T>}
     */
    (lookup, item) => {
      lookup.set(keyExtractor(item), item);
      return lookup;
    },
    new Map(),
  );
}

export function wait(duration = 0): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, duration));
}
